import type { FetcherWithComponents } from '@remix-run/react';
import type {
    CopyDesignBoardPinsMutation,
    MoveDesignBoardPinsMutation,
} from 'generated/graphql';
import { API_ACTIONS } from '@modules/design-board/config';
import type { PinFetcherFunction } from '@modules/design-board/component/right-side-drawer/DesignBoardDrawerSelectPinsBody';
import { clearAllDesignBoardCache } from '@rocco/ui/design-board/components/DesignBoardsActions';
import { COPY_BUILD_HUB_INSPIRATION_ITEMS_API_ROUTE } from '~/routes/remix-api.app.build-hub-inspiration-items-copy';
import { MOVE_BUILD_HUB_INSPIRATION_ITEMS_API_ROUTE } from '~/routes/remix-api.app.build-hub-inspiration-items-move';

interface PinBoardClickedAction {
    destinationBoardId: number;
    boardId: number;
    pinListString: string;
    onError: (errorMsg: string) => void;
    buildHubUrl?: string;
}

export interface MoveToBoardClickedProps extends PinBoardClickedAction {
    pinFetcher: FetcherWithComponents<MoveDesignBoardPinsMutation>;
}

export interface CopyToBoardClickedProps extends PinBoardClickedAction {
    pinFetcher: FetcherWithComponents<CopyDesignBoardPinsMutation>;
}

export const moveToBoardClicked: PinFetcherFunction = (props) => {
    const { destinationBoardId, boardId, pinListString, onError, pinFetcher } =
        props;
    if (boardId === destinationBoardId) {
        onError('Cannot move pins to the same board');
    } else {
        pinFetcher.submit(
            {
                boardId: `${boardId}`,
                destinationBoardId: `${destinationBoardId}`,
                pinIds: pinListString,
                _action: API_ACTIONS.MOVE_DESIGN_BOARD_PINS,
            },
            {
                method: 'post',
            }
        );

        clearAllDesignBoardCache();
    }
};

export const copyToBoardClicked: PinFetcherFunction = ({
    destinationBoardId,
    boardId,
    pinListString,
    onError,
    pinFetcher,
}) => {
    if (boardId === destinationBoardId) {
        onError('Cannot move pins to the same board');
    } else {
        pinFetcher.submit(
            {
                boardId: `${boardId}`,
                destinationBoardId: `${destinationBoardId}`,
                pinIds: pinListString,
                _action: API_ACTIONS.COPY_DESIGN_BOARD_PINS,
            },
            {
                method: 'post',
            }
        );

        clearAllDesignBoardCache();
    }
};

export const moveToMoodBoardClicked: PinFetcherFunction = ({
    destinationBoardId,
    boardId,
    pinListString,
    onError,
    pinFetcher,
    buildHubUrl,
}) => {
    if (boardId === destinationBoardId) {
        onError('Cannot move pins to the same board');
    } else if (!buildHubUrl) {
        onError('cannot move mood board pins outside of build hub');
    } else {
        const formData = new FormData();
        formData.set('boardId', boardId.toString());
        formData.set('destinationBoardId', destinationBoardId.toString());
        formData.set('pinListString', pinListString);
        formData.set('buildHubUrl', buildHubUrl);

        pinFetcher.submit(formData, {
            method: 'post',
            action: MOVE_BUILD_HUB_INSPIRATION_ITEMS_API_ROUTE,
        });

        clearAllDesignBoardCache();
    }
};

export const copyToMoodBoardClicked: PinFetcherFunction = ({
    destinationBoardId,
    boardId,
    pinListString,
    onError,
    pinFetcher,
    buildHubUrl,
}) => {
    if (boardId === destinationBoardId) {
        onError('Cannot move pins to the same board');
    } else if (!buildHubUrl) {
        onError('cannot move mood board pins outside of build hub');
    } else {
        const formData = new FormData();
        formData.set('boardId', boardId.toString());
        formData.set('destinationBoardId', destinationBoardId.toString());
        formData.set('pinListString', pinListString);
        formData.set('buildHubUrl', buildHubUrl);

        pinFetcher.submit(formData, {
            method: 'post',
            action: COPY_BUILD_HUB_INSPIRATION_ITEMS_API_ROUTE,
        });

        clearAllDesignBoardCache();
    }
};
